/** 勧誘コード（機能仕様1.12）：英数字と - _ の2〜20文字。大文字にそろえる。形が違えば null（勧誘コードなし） */
export function normalizeReferralCode(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const v = raw.trim().toUpperCase();
  return /^[A-Z0-9_-]{2,20}$/.test(v) ? v : null;
}
